import { DesignData } from '../types';

import isFlatDesign from './isFlatDesign';

// How far ahead the add/remove-pages buttons must look to gate on min/max, i.e.
// a lower bound on the page-count delta of a single click.
//
// Flat books (brochures) move a full `increment` of pages per click, and a
// product's max is not guaranteed to sit on the increment grid, so their gating
// must look a whole increment ahead to avoid enabling a click that overshoots.
//
// Spread books (photobooks) also move a full grid step per click, but that step
// is the ecommerce variant spacing when sold online (which can be smaller than
// `increment`) and `increment` otherwise. Rather than thread that per-context
// value through every button, we use 1 here: on a grid-aligned page count, being
// strictly inside min/max already guarantees one more step fits, so 1 is a safe
// lower bound for both cases and avoids over-disabling the ecommerce path.
function getPageCountStep(designData: DesignData | undefined, increment: number | undefined): number {
  if (designData && increment && isFlatDesign(designData)) {
    return increment;
  }
  return 1;
}

export default getPageCountStep;
